import React, { MouseEventHandler } from "react";
import { Button } from "components/ui";

interface OfferAuthOtpConfirmButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled: boolean;
  loading: boolean;
  label: string;
  wideOnDesktop: boolean;
}

const OfferAuthOtpConfirmButton = ({
  onClick,
  disabled,
  loading,
  label,
  wideOnDesktop,
}: OfferAuthOtpConfirmButtonProps) => (
  <Button
    type="unstyled"
    onClick={onClick}
    disabled={disabled}
    className={`mt-6 w-full max-w-sm ${
      wideOnDesktop ? "lg:max-w-none" : ""
    } flex justify-center p-3 rounded-md disabled:pointer-events-none text-sm font-semibold text-white bg-landing-red hover:bg-hover-landing-red focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black focus:ring-hover-landing-red disabled:opacity-75`}
  >
    {loading ? (
      <span className="flex animate-spin mr-3">
        <span className="rounded-full border-2 border-white border-b-black h-4 w-4" />
      </span>
    ) : null}
    {label}
  </Button>
);

export default OfferAuthOtpConfirmButton;
